export enum DifferenceMapsAssessment {
  SMILEY_FACE = 'SmileyFace',
  BULLS_EYE = 'BullsEye',
  CENTRAL_ISLAND = 'CentralIsland'
}
